<template>
  <IntegrationBadgesRow
    :linkedin-url="data?.linkedin_url || null"
    :salesforce-url="salesforceUrl"
    :hubspot-url="hubspotUrl"
    :pipedrive-url="pipedriveUrl"
    :leadiq-enriched="data?.leadiq_enrichment_status === 'succeeded'"
    :size="size"
  />
</template>

<script setup lang="ts">
import { computed, onMounted, ref } from 'vue'
import IntegrationBadgesRow from './IntegrationBadgesRow.vue'
import { getSalesforceUrl } from '../services/salesforce'
import { getHubspotUrl, getPipedriveUrl, preloadCrmLinkConfig } from '../services/crmLinks'

export type ContactIntegrationBadgesData = {
  linkedin_url?: string | null
  salesforce_contact_id?: string | null
  salesforce_lead_id?: string | null
  hubspot_contact_id?: string | null
  pipedrive_person_id?: string | null
  leadiq_enrichment_status?: string | null
}

const props = withDefaults(defineProps<{
  data?: ContactIntegrationBadgesData | null
  size?: number
}>(), {
  size: 14,
})

const crmReady = ref(false)
onMounted(async () => { await preloadCrmLinkConfig(); crmReady.value = true })

// Prefer the Contact record; fall back to the Lead record -- a contact is
// linked to at most one of the two.
const salesforceUrl = computed(() => {
  const d = props.data
  if (!d) return null
  if (d.salesforce_contact_id) return getSalesforceUrl({ Id: d.salesforce_contact_id }, 'Contact')
  if (d.salesforce_lead_id) return getSalesforceUrl({ Id: d.salesforce_lead_id }, 'Lead')
  return null
})
const hubspotUrl = computed(() => {
  void crmReady.value
  return props.data?.hubspot_contact_id
    ? getHubspotUrl('contact', props.data.hubspot_contact_id)
    : null
})
const pipedriveUrl = computed(() => {
  void crmReady.value
  return props.data?.pipedrive_person_id
    ? getPipedriveUrl('person', props.data.pipedrive_person_id)
    : null
})
</script>
